import React from 'react';
import { Form, Input, Button } from 'antd';
import AdminLayout from "@/components/layout/admin/adminLayout";
import { groupApi } from "@/api/group";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useNavigate} from "react-router-dom";
import {URLS} from "@/lib/urls";
import {sprintf} from "@/lib/utils/sprintf";

const { TextArea } = Input;

function AdminGroupCreatePage() {
    const { mutate } = groupApi.useAdminCreateGroup();
    const navigate = useNavigate();

    const [form] = Form.useForm();

    const handleSubmit = (values) => {
        mutate({
            ...values
        }, {
            onSuccess: (res) => {
                ApiHandleSuccessMessage(res)
                navigate(sprintf(URLS.admin.group.edit, {id: res?.data?.data?.id}))
            },
            onError: (err) => {
                ApiHandleErrorMessage(err)
            }
        })
    };

    return (
        <AdminLayout pageTitle={'افزودن گروه علمی'} backTo={URLS.admin.group.list}>
            <div className="w-full p-4 sm:p-6">
                <div className="mx-auto w-full max-w-3xl rounded-xl border border-gray-200 dark:border-gray-700 p-4 shadow-sm sm:p-6 md:p-8">

                    <div className="mb-6">
                        <h2 className="text-lg font-bold sm:text-xl">
                            اطلاعات گروه علمی
                        </h2>
                        <p className="mt-2 text-sm text-gray-500">
                            لطفاً اطلاعات گروه علمی جدید را وارد کنید.
                        </p>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                        requiredMark="optional"
                        autoComplete="off"
                    >
                        <Form.Item
                            label="عنوان"
                            name="title"
                        >
                            <Input
                                size="middle"
                                placeholder="عنوان گروه علمی"
                                className="!rounded-lg"
                            />
                        </Form.Item>

                        <Form.Item
                            label="توضیحات"
                            name="desc"
                        >
                            <TextArea
                                rows={5}
                                placeholder="توضیحاتی درباره گروه علمی وارد کنید..."
                                className="!rounded-lg"
                            />
                        </Form.Item>

                        <div className="flex flex-col-reverse gap-3 border-t dark:border-gray-700 pt-5 sm:flex-row sm:justify-end">

                            <Button
                                type="primary"
                                htmlType="submit"
                                size="middle"
                                className="!rounded-lg"
                            >
                                ثبت گروه علمی
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </AdminLayout>
    );
}

export default AdminGroupCreatePage;